import { autocomplete, debouncedAutocomplete } from './autocomplete';
import { getPlaceDetails } from './details';

export default {
  autocomplete,
  debouncedAutocomplete,
  getPlaceDetails,
};
